"use strict";
var root_1 = require('../util/root');
var Symbol = root_1.root.Symbol;
exports.$$rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
//# sourceMappingURL=rxSubscriber.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/symbol/rxSubscriber.js
// module id = 110
// module chunks = 2